module.exports = __webpack_public_path__ + "static/img/empty_icon.c2c00f4e.png";